import { jsx as a } from "react/jsx-runtime";
import { Container as e } from "./styles.js";
const i = ({ children: r, className: t }) => /* @__PURE__ */ a(e, { gap: 4, align: "stretch", direction: "column", className: t, children: r });
i.displayName = "StepWizardPage";
export {
  i as StepWizardPage
};
//# sourceMappingURL=StepWizardPage.js.map
